import React, { useState, useEffect, useCallback, useMemo } from 'react';
import '../styles/ImageCarousel.css';

const ImageCarousel = ({ language }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const baseUrl = process.env.PUBLIC_URL || '';

  const carouselImages = useMemo(() => [
    { name: 'DCM', en: `${baseUrl}/assets/DCMQK Eng.png`, kn: `${baseUrl}/assets/DCMQK.png` },
    { name: 'HARISH', en: `${baseUrl}/assets/HARISHQE.png`, kn: `${baseUrl}/assets/HARISHQK.png` },
    { name: 'ATHEEQ', en: `${baseUrl}/assets/ATHEEQE.png`, kn: `${baseUrl}/assets/ATHEEQK.png` }
  ], [baseUrl]);

  const getImageSrc = useCallback((image) => 
    language === 'kannada' ? image.kn : image.en,
    [language]
  );

  useEffect(() => {
    setCurrentSlide(0);
    setIsPaused(false);
  }, [language]);

  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % carouselImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [carouselImages.length, isPaused]);

  const handleImageClick = useCallback((e, index) => {
    e.preventDefault();
    e.stopPropagation();
    setIsPaused(true);
    setCurrentSlide(index);
    setTimeout(() => setIsPaused(false), 5000);
  }, []);

  return (
    <div className="about-carousel-section">
      <div className="image-carousel-container">
        <div className="image-carousel-wrapper">
          {carouselImages.map((image, index) => {
            const prevIndex = (currentSlide - 1 + carouselImages.length) % carouselImages.length;
            const nextIndex = (currentSlide + 1) % carouselImages.length;
            const isVisible = index === currentSlide || index === prevIndex || index === nextIndex;
            
            if (!isVisible) return null;

            let positionClass = '';
            if (index === currentSlide) positionClass = 'active';
            else if (index === prevIndex) positionClass = 'prev';
            else if (index === nextIndex) positionClass = 'next';
            
            return (
              <div
                key={`${image.name}-${index}`}
                className={`image-card ${positionClass}`}
                onClick={(e) => handleImageClick(e, index)}
              >
                <img 
                  src={getImageSrc(image)} 
                  alt={`${image.name} ${language === 'kannada' ? 'Kannada' : 'English'}`}
                  className="carousel-image"
                  loading="lazy"
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ImageCarousel;
